import React, { useState, useEffect } from 'react';
import { User, Trash, Edit, UserPlus, X, Check } from 'lucide-react';
import {
  getInvitedEmployees,
  createEmployeeInvite,
  removeEmployee,
} from "../../services/operations/adminAPI";
import toast from 'react-hot-toast';



const UserManagement = () => {
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isEditMode, setIsEditMode] = useState(false);
  const [selectedUser, setSelectedUser] = useState(null);
  
  // Form state
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [role, setRole] = useState('employee');
  
  const fetchUsers = async () => {
    try {
      const response = await getInvitedEmployees();
      console.log(response)
      setUsers(response.data);
    } catch (error) {
      console.error('Error fetching users:', error);
      toast.error('Failed to load users');
    } finally {
      setLoading(false);
    }
  };
  // Load users
  useEffect(() => {
    
    
    fetchUsers();
  }, []);
  
  const openAddModal = () => {
    setIsEditMode(false);
    setSelectedUser(null);
    resetForm();
    setIsModalOpen(true);
  };
  
  const openEditModal = (user) => {
    setIsEditMode(true);
    setSelectedUser(user);
    setName(user.name);
    setEmail(user.email);
    setPassword('');
    setRole(user.role);
    setIsModalOpen(true);
  };
  
  const resetForm = () => {
    setName('');
    setEmail('');
    setPassword('');
    setRole('employee');
  };
  
  const closeModal = () => {
    setIsModalOpen(false);
    resetForm();
  };
  
  const handleSubmit = async (e) => {
    e.preventDefault();
    
    try {
      if (isEditMode && selectedUser) {
        // Update existing user
        const userData = {
          name,
          email,
          role,
          ...(password ? { password } : {}),
        };
        
        await await createEmployeeInvite(userData);
        
        // Update user in state
        setUsers(prev => 
          prev.map(user => 
            user._id === selectedUser._id ? { ...user, name, email, role } : user
          )
        );
        
        toast.success('User updated successfully');
      } else {
        // Create new user
        const response = await createEmployeeInvite({
          name,
          email,
          password,
          role,
        }) ;
        console.log(response)
        fetchUsers()
        // Add new user to state
        setUsers(prev => [...prev, response.data]);
        
        toast.success('User created successfully');
      }
      
      closeModal();
    } catch (error) {
      toast.error(error.response?.data?.message || 'Failed to save user');
    }
  };
  
  const handleDeleteUser = async (userId) => {
    if (!window.confirm('Are you sure you want to delete this user?')) {
      return;
    }
    
    try {
      await removeEmployee(userId);

      
      // Remove user from state
      setUsers(prev => prev.filter(user => user._id !== userId));
      
      toast.success('User deleted successfully');
    } catch (error) {
      toast.error('Failed to delete user');
    }
  };
  
  if (loading) {
    return (
      <div className="flex justify-center items-center h-64">
        <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-blue-500"></div>
      </div>
    );
  }
  
  return (
    <div className="space-y-6">
      <div className="flex justify-between items-center">
        <div>
          <h1 className="text-2xl font-bold text-gray-900">User Management</h1>
          <p className="text-gray-600">Manage system users and their access levels.</p>
        </div>
        <button
          onClick={openAddModal}
          className="btn btn-primary flex items-center"
        >
          <UserPlus className="h-5 w-5 mr-2" />
          Add User
        </button>
      </div>
      
      {/* User List */}
      <div className="bg-white shadow overflow-hidden sm:rounded-md">
        <ul className="divide-y divide-gray-200">
          {users.length === 0 ? (
            <li className="px-6 py-4 text-center text-gray-500">
              No users found.
            </li>
          ) : (
            users.map((user) => (
              <li key={user._id} className="px-6 py-4">
                <div className="flex items-center justify-between">
                  <div className="flex items-center">
                    <div className="flex-shrink-0">
                      <div className="h-10 w-10 rounded-full bg-gray-200 flex items-center justify-center">
                        <User className="h-6 w-6 text-gray-600" />
                      </div>
                    </div>
                    <div className="ml-4">
                      <div className="text-sm font-medium text-gray-900">{user.firstName} {user.lastName}</div>
                      <div className="text-sm text-gray-500">{user.email}</div>
                    </div>
                  </div>
                  <div className="flex items-center">
                    <span className={`px-2 inline-flex text-xs leading-5 font-semibold rounded-full ${
                      user.role === 'admin' ? 'bg-purple-100 text-purple-800' : 'bg-blue-100 text-blue-800'
                    }`}>
                      {user.accountType}
                    </span>
                    <div className="ml-4 flex-shrink-0 flex">
                      {/* <button
                        onClick={() => openEditModal(user)}
                        className="mr-2 text-gray-400 hover:text-gray-500"
                      >
                        <Edit className="h-5 w-5" />
                      </button> */}
                      <button
                        onClick={() => handleDeleteUser(user._id)}
                        className="text-gray-400 hover:text-red-500"
                      >
                        <Trash className="h-5 w-5" />
                      </button>
                    </div>
                  </div>
                </div>
              </li>
            ))
          )}
        </ul>
      </div>
      
      {/* Add/Edit User Modal */}
      {isModalOpen && (
        <div className="fixed inset-0 bg-gray-500 bg-opacity-75 flex items-center justify-center z-50 "
        style={{marginTop:0}}>
          <div className="bg-white rounded-lg shadow-xl max-w-md w-full mx-4">
            <div className="flex justify-between items-center px-6 py-4 border-b">
              <h3 className="text-lg font-medium text-gray-900">
                {isEditMode ? 'Edit User' : 'Add New User'}
              </h3>
              <button
                onClick={closeModal}
                className="text-gray-400 hover:text-gray-500"
              >
                <X className="h-6 w-6" />
              </button>
            </div>
            
            <form onSubmit={handleSubmit} className="px-6 py-4">
              <div className="space-y-4">
                
                
                <div>
                  <label htmlFor="email" className="block text-sm font-medium text-gray-700">
                    Email
                  </label>
                  <input
                    type="email"
                    id="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    className="input mt-1"
                    required
                  />
                </div>
                
               
              </div>
              
              <div className="mt-6 flex justify-end space-x-3">
                <button
                  type="button"
                  onClick={closeModal}
                  className="btn btn-secondary"
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  className="btn btn-primary"
                  disabled={loading}
                >
                  {loading ? 'Loading...' : (isEditMode ? 'Update User' : 'Add User')}
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
};

export default UserManagement;